<!--@if((dataLayout$ | async) === 'vertical'){-->
<!--<app-vertical></app-vertical>-->
<!--}-->
<!--@if((dataLayout$ | async)==='horizontal'){-->
<!--<app-horizontal></app-horizontal>-->
<!--}-->

<app-vertical></app-vertical>
